import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { NgxEchartsModule } from 'ngx-echarts';
import { } from 'echarts';
import { AgmCoreModule } from '@agm/core';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { ArchwizardModule } from 'angular-archwizard';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { NgbModule, NgbProgressbarModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { DragulaModule } from 'ng2-dragula';
//import { NgxTimelineModule } from '@frxjs/ngx-timeline';


@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [CommonModule, BrowserModule, ArchwizardModule,
    NgbProgressbarModule,  AgmCoreModule.forRoot({
    apiKey: 'AIzaSyDDNunlrlRApoo4bo5L8V5fMcBCTjZDbK8',
    libraries: ['places']}),
    IonicModule.forRoot(), AppRoutingModule, DragulaModule.forRoot(), NgbModule, HttpClientModule, NgxEchartsModule.forRoot({
    echarts: () => import('echarts'),
  }),
  AgmCoreModule.forRoot({
    apiKey: 'AIzaSyDDNunlrlRApoo4bo5L8V5fMcBCTjZDbK8',
    libraries: ['places']}),
],
  providers: [{ provide: LocationStrategy, useClass: HashLocationStrategy }],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {}
